import { Col, Row } from 'antd';
import React from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import TranslateText from 'components/hoc/TranslateText';
import LeiLoginlessFooter from 'components/molecules/Lei/zadostLeiLoginless/LeiLoginlessFooter';
import LeiLoginlessMenu from 'components/molecules/Lei/zadostLeiLoginless/LeiLoginlessMenu';

const Faq: React.FC = () => {
    return (
        <>
            <LeiLoginlessMenu />
            <Row
                id="Faq"
                style={{
                    paddingTop: 24,
                    paddingBottom: 24,
                    display: 'block',
                    background: 'white'
                }}
            >
                <div
                    style={{
                        margin: '0 auto',
                        maxWidth: 1200
                    }}
                >
                    <Col
                        style={{
                            display: 'block',
                            paddingLeft: 20,
                            maxWidth: 800,
                            background: 'white'
                        }}
                    >
                        <h1
                            style={{
                                color: '#007777'
                            }}
                        >
                            Časté dotazy
                        </h1>

                        <h2 id="1">Jak dlouho trvá získání kódu LEI?</h2>
                        <p>
                            Pokud požádáte o přidělení kódu LEI, můžete jej obdržet za méně než dvacet čtyři hodin. V
                            případě, že je žádost v pořádku a jsou doloženy všechny skutečnosti garantujeme vydání LEI
                            do dvou pracovním dnů.
                        </p>
                        <h2 id="1">Proč si mám vybrat službu LEI od CDCP, a. s.?</h2>
                        <p>
                            Protože vám nabízíme vysoce kvalitní a spolehlivou službu CDCP je největším vydavatelem i
                            správcem kódů LEI v České republice. Zároveň jsme jediným českým subjektem, který obdržel
                            akreditaci pro přidělování a správu kódu LEI.
                        </p>
                        <h2 id="1">Co je potvrzení o přidělení/prodloužení kódu LEI?</h2>
                        <p>
                            Potvrzení o přidělení LEI je elektronicky podepsaný dokument s hlavními údaji (datum vydání,
                            datum expirace atd) o vašem kódu LEI, a který obdržíte na svůj email po vždy po
                            vydání/prodloužení kódu LEI. Za zaslané potvrzení není účtován žádný dodatečný poplatek.
                        </p>
                        <h2 id="1">Jak mohu požádat o kód LEI?</h2>

                        <AnchorComponent
                            id="downloadPlnaMocBtn"
                            href={
                                window.location.href.includes('test')
                                    ? 'https://test.cdcp.cz/wp-content/uploads/md/LEI-plnaMoc.pdf'
                                    : 'https://www.cdcp.cz/wp-content/uploads/md/LEI-plnaMoc.pdf'
                            }
                            download="Lei plná moc.pdf"
                            target="_blank"
                        >
                            <TranslateText> Návod na přidělení kódu LEI</TranslateText>
                        </AnchorComponent>
                        <br />
                        <AnchorComponent
                            id="downloadPlnaMocBtn"
                            href={
                                window.location.href.includes('test')
                                    ? 'https://test.cdcp.cz/wp-content/uploads/md/LEI-plnaMoc.pdf'
                                    : 'https://www.cdcp.cz/wp-content/uploads/md/LEI-plnaMoc.pdf'
                            }
                            download="Lei plná moc.pdf"
                            target="_blank"
                        >
                            <TranslateText>Návod na prodloužení kódu LEI</TranslateText>
                        </AnchorComponent>
                        <h2 id="1">Jak mohu zaplatit za kód LEI?</h2>

                        <p>
                            Pokud chcete požádat o kód LEI nebo jej obnovit, můžete zaplatit kreditní kartou nebo
                            bankovním převodem.
                        </p>
                        <h2 id="1">Jak obdržím fakturu za přidělení/prodloužení platnosti kódu LEI?</h2>
                        <p>Fakturu Vám uložíme do portálu můj depozitář, případně Vám bude zaslána na mail? </p>

                        <h2 id="1">Jsem součástí konsolidované společnosti? </h2>

                        <p>
                            Od 1. května 2017 je pro podání žádosti o přidělení nebo obnovení kódu LEI nutné poskytnout
                            některé informace týkající se struktury společnosti. Pokud jste právnickou osobou, která je
                            součástí skupiny společností, musíte zadat základní údaje týkající se mateřské společnosti
                            nebo holdingové společnosti a poskytnout poslední konsolidovanou účetní závěrku. Pokud
                            nejste součástí podnikatelské skupiny, stačí prohlásit, že nejste pod kontrolou jiné
                            právnické osoby.
                        </p>

                        <h2 id="1">Mohu požádat o kód LEI jako zmocněnec?</h2>

                        <p>
                            Samozřejmě! Můžete požádat o kód pro svého klienta: stačí k žádosti přiložit plnou moc
                            podepsanou zákonným zástupcem společnosti, pro kterou žádáte o přidělení/prodloužení kódu
                            LEI. Návod zde.
                        </p>
                        <h2 id="1">Co mám dělat, pokud platnost mého kódu LEI vypršela?</h2>

                        <p>
                            Pokud platnost vašeho kódu LEI vypršela, nemusíte se obávat, kód vám zůstává přidělen, i
                            když jej nemůžete používat.
                        </p>
                        <p>
                            Pokud jej chcete znovu používat, musíte jej obnovit prostřednictvím žádosti o Prodloužení
                            platnosti kódu LEI + odkaz.
                        </p>
                        <h2 id="1">Jak mohu obnovit kód LEI?</h2>

                        <p>
                            Pokud chcete obnovit svůj kód LEI, proveďte tak prostřednictvím těchto stránek(ve veřejné
                            části i v logované části portálu Můj depozitář) a použijte žádost o Prodloužení platnosti
                            kodu LEI. Obnovení provedete pomocí několika jednoduchých kroků v rámci online průvodce.
                        </p>
                        <h2 id="1">Jaký je rozdíl mezi obnovením a převodem kódu LEI? </h2>

                        <p>Obnovení kódu je něco, co provádíte každý rok, aby váš aktivovaný kód zůstal platný.</p>
                        <p>
                            Převod kódu LEI naopak vyžaduje, aby byl váš kód převeden od současného poskytovatele k
                            jinému. Převod je zdarma(v případě, že je vaše LEI již neplatné, je nutné při převodu
                            uhradit poplatek za prodloužení LEI) a váš kód LEI zůstává stejný. Služba pro převod LEI do
                            správy CDCP, a. s. je k dispozici zde.
                        </p>
                        <h2 id="1">
                            Může CDCP, a. s. vydávat/spravovat kódy LEI pro právnické osoby se sídlem v zahraničí?
                        </h2>

                        <p>
                            Ano může,{' '}
                            <AnchorComponent
                                id="downloadPlnaMocBtn"
                                href={'https://www.cdcp.cz/wp-content/uploads/CDCP_Akreditovane_jurisdikce_LEI.pdf'}
                                download="Lei plná moc.pdf"
                                target="_blank"
                            >
                                <TranslateText>seznam akreditovaných jurisdikcí</TranslateText>
                            </AnchorComponent>
                        </p>
                        <h2 id="1">Kde mohu zkontrolovat datum platnosti svého kódu LEI?</h2>

                        <p>
                            Chcete-li zjistit datum platnosti kódu LEI, můžete navštívit webovou stránku www.cdcp.cz/LEI
                            LEI a pomocí vyhledávací funkce zobrazit jeden z navrhovaných parametrů, který zobrazí
                            souhrn údajů spojených s kódem LEI.
                        </p>
                        <h2>Kde mohu zkontrolovat datum platnosti svého kódu LEI?</h2>
                        <p>
                            Chcete-li zjistit datum platnosti kódu LEI, můžete navštívit webovou stránku www.cdcp.cz/LEI
                            LEI a pomocí vyhledávací funkce zobrazit jeden z navrhovaných parametrů, který zobrazí
                            souhrn údajů spojených s kódem LEI.
                        </p>

                        <h2>Jaké dokumenty jsou potřebné k podání žádosti o kód LEI?</h2>
                        <p>
                            V závislosti na typu subjektu (společnost zapsaná v obchodním rejstříku, investiční fond,
                            veřejná správa atd.), pro který pracujete, může být nutné přiložit různé dokumenty. Seznam
                            potřebných dokumentů a pokyny k jejich přiložení najdete při vyplňování žádosti.
                        </p>

                        <h2>Mám kód LEI, ale potřebuji aktualizovat informace, jak mám postupovat?</h2>
                        <p>
                            V případě, že je LEI kód platný a chcete provést aktualizaci údajů, proveďte tak po
                            přihlášení se do portálu Můj depozitář. V případě, že kódu LEI vypršela platnost proveďte
                            aktualizaci prostřednictvím žádosti o Prodloužení platnosti kódu LEI, prostřednictvím které
                            po uhrazení poplatku zároveň prodloužíte platnost na další rok.
                        </p>

                        <h2>Kdo musí mít kód LEI?</h2>
                        <p>
                            Od 3. ledna 2018 se podle evropských předpisů požadavek na kód LEI rozšířil na všechny
                            právnické osoby, které provádějí transakce na kapitálových trzích (pro transakce týkající se
                            akcií, dluhopisů, opčních listů, státních dluhopisů atd.) nebo které obchodují s
                            derivátovými nástroji.
                        </p>

                        <h2>K čemu mohu použít vyhledávací funkce?</h2>
                        <p>
                            Vyhledávací funkci můžete použít k vyhledání kódů LEI vydaných a spravovaných společností
                            CDCP, a. s.
                        </p>

                        <h2>Jak dlouho je kód LEI platný?</h2>
                        <p>
                            Kód LEI je platný po dobu jednoho roku, následně je nutné provést aktualizaci údajů a
                            uhradit poplatek za prodloužení platnosti kódu LEI.
                        </p>

                        <h2>Už kód LEI nechci, co mám dělat?</h2>
                        <p>
                            Doporučujeme vám zkontrolovat seznam subjektů, které jej musí mít, aby mohly působit na
                            kapitálových/derivátových trzích. Pokud zjistíte, že kód LEI nepotřebujete, jednoduše jej po
                            uplynutí platnosti neobnovujte. V případě zániku společnosti se LEI kód ruší automaticky.
                        </p>

                        <h2>Co je to příznak "Conformity Flag Policy"?</h2>
                        <p>
                            Příznak souladu s politikou je jednoduchý a přehledný nástroj, který umožňuje všem
                            zainteresovaným stranám určit, které záznamy LEI (tj. soubor údajů souvisejících s kódem
                            LEI) splňují určité politiky Výboru pro regulační dohled (ROC). ROC koordinuje a dohlíží na
                            globální systém LEI.
                        </p>
                        <p>
                            Záznam LEI označený jako „vyhovující“ znamená, že jsou splněna následující kritéria:
                            <br />
                            Registrace LEI je aktuální – obnovení záznamu LEI (a tedy i přezkoumání údajů týkajících se
                            právnické osoby) bylo dokončeno ve stanovené lhůtě.
                            <br />
                            Prohlášení o údajích o struktuře společnosti je úplné – právnická osoba poskytla údaje o
                            přímých a konečných mateřských společnostech (nebo uvedla jeden ze stanovených důvodů, proč
                            tyto údaje nemohou být poskytnuty).
                        </p>
                        <p>
                            Příznak se zobrazuje v globální databázi LEI, kterou spravuje organizace GLEIF.{' '}
                            <AnchorComponent
                                id="downloadPlnaMocBtn"
                                href={'https://www.cdcp.cz/wp-content/uploads/CDCP_Akreditovane_jurisdikce_LEI.pdf'}
                                download="Lei plná moc.pdf"
                                target="_blank"
                            >
                                <TranslateText>Odkaz zde</TranslateText>
                            </AnchorComponent>
                        </p>
                    </Col>
                </div>
            </Row>
            <LeiLoginlessFooter />
        </>
    );
};

export default Faq;
